import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { getAllLocation } from "../../../actions/warehouseAction";
import Report from "./Report";
import Excelldownload from "./Excelldownload";
import { DatePicker, Select, TreeSelect, Col, Space, Row, Button } from "antd";
import moment from "moment";
import ReactToPrint from "react-to-print";
import PdfDownload from "./PdfDownload";

const Maincontent = ({
  RoleList,
  businessprofile,
  locationlist,
  employeeList,
  getAllLocation,
  auth,
}) => {
  const { RangePicker } = DatePicker;
  const [updatelist, setUpdatelist] = useState(true);
  const [reload, setreload] = useState(false);
  
  const dateFormat = "YYYY-MM";
  const { Option } = Select;
  const [fromMonth, setFromMonth] = useState(moment().format("YYYY-MM"));
  const [toMonth, setToMonth] = useState(moment().format("YYYY-MM"));
  
  const employee = useRef("");
  const selectedLocation = useRef("");

  const [data, setData] = useState([]);
  const componentRef = useRef();

  useEffect(() => {
    getAllLocation();
  }, []);

  const onEmployeeChange = (value) => {
    employee.current = value;
  };

  const onFromMonthChange = (date, dateString) => {
    if (date) {
      setFromMonth(dateString);
    }
  };

  const onToMonthChange = (date, dateString) => {
    if (date) {
      setToMonth(dateString);
    }
  };

  const handleSearch = () => {
    setreload(!reload);
  };

  return (
    <>
      <Row  align="bottom">
        <Col flex="auto">
          From Month :
          <DatePicker
            picker="month"
            style={{ width: "100%" }}
            defaultValue={moment()}
            format={dateFormat}
            onChange={onFromMonthChange}
          />
        </Col>

        <Col flex="auto">
          To Month :
          <DatePicker
            picker="month"
            style={{ width: "100%" }}
            defaultValue={moment()}
            format={dateFormat}
            onChange={onToMonthChange}
          />
        </Col>

        <Col flex="auto">
          Employee :
          <Select
            showSearch
            placeholder="Please select a Employee"
            style={{ width: "100%" }}
            onChange={(value) => onEmployeeChange(value)}
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            <Option value="" select>
              All
            </Option>
            {employeeList.map((employee) => {
              return <Option value={employee.id}>{employee.name}</Option>;
            })}
          </Select>
        </Col>

        {auth.permissions.includes("HRM.Attendance Report_is_location") ||
        auth.superuser ? (
          <Col flex="auto">
            Location :
            <Select
              showSearch
              placeholder="Please select a Location"
              style={{ width: "100%" }}
              onChange={(value) => {
                selectedLocation.current = value;
              }}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              <Option value="" select>
                All
              </Option>
              {locationlist.map((location) => {
                return <Option value={location.id}>{location.name}</Option>;
              })}
            </Select>
          </Col>
        ) : (
          ""
        )}

        <Col flex="auto">
          <Button
            type="primary"
            style={{ width: "100%" }}
            onClick={handleSearch}
          >
            Search
          </Button>
        </Col>

        <Col flex="auto">
          Print:
          <ReactToPrint
            trigger={() => (
              <Button
                style={{
                  width: "100%",
                }}
                type="primary"
              >
                Print this out!
              </Button>
            )}
            content={() => componentRef.current}
          />
        </Col>
      </Row>

      <div className="site-layout-background main-frame">
        <div ref={componentRef} style={{ padding: "10px" }}>
          <Report
            fromMonth={fromMonth}
            toMonth={toMonth}
            componentRef={componentRef}
            employee={employee.current}
            data={data}
            setData={setData}
            updatelist={updatelist}
            setUpdatelist={setUpdatelist}
            reload={reload}
            setreload={setreload}
            selectedLocation={selectedLocation.current}
          />
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    employeeList: state.employee.employeelist,
    locationlist: state.warehouse.locationlist,
    businessprofile: state.settings.businessprofile,
  };
};

export default connect(mapStateToProps, { getAllLocation })(Maincontent);
